export default {"src":"/_next/static/media/disc-wheels.54645a56.svg","height":351,"width":480,"blurWidth":0,"blurHeight":0};